import { pagingOptions, sortByFn } from "../helpers/index";
import EventBus from "../store/event-bus";
export const ListMixin = {
  props: {
    height: {
      type: Number,
      default: () => 750,
    },
    hideActions: {
      type: Boolean,
      default: () => false,
    },
    fixedHeader: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      pagingOptions,
      search: "",
      first: 25,
      pageSize: 25,
      after: null,
      loadMoreEnabled: true,
      totalItems: 0,
      searchParams: {},
      sort: this.$store.getters.localSettings(`${this.refName}-sort`, {
        fieldName: "id",
        direction: "DESC",
      }),
      windowHeight: window.innerHeight,
    };
  },

  computed: {
    sortBy() {
      const listSort = this.$store.getters.localSettings(
        `${this.refName}-sort`
      );
      return listSort ? listSort.fieldName : "";
    },
    sortDesc() {
      const listSort = this.$store.getters.localSettings(
        `${this.refName}-sort`
      );
      return listSort ? listSort.direction == "DESC" : false;
    },
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.items && this.items.length >= 20
        ? this.windowHeight - 230
        : null;
    },
    filteredHeaders() {
      // return [
      //   ...this.headers.filter(
      //     (h) =>
      //       this.visibleColumns.indexOf(h.name) > -1 ||
      //       h.name == "actions" ||
      //       h.name == "menuActions"
      //   ),
      // ];
      const hs = [];
      // for (const headerName of this.visibleColumns.filter(
      //   (c) => c != "actions"
      // )) {

      /*
        http://tracker.globetrack.ie/issues/5658
        this way you are able to controll columns order by simply manipulating header table...

      const hs = this.headers.filter((h) =>
        this.visibleColumns.includes(h.name)
      );
      */

      for (const headerName of this.visibleColumns) {
        const h = this.headers.find((h) => h.name == headerName);
        if (h) {
          hs.push(h);
        }
      }

      // const actionsHeader = this.headers.find((h) => h.name == "actions");
      // if (actionsHeader) {
      //   hs.push(actionsHeader);
      // }
      return this.hideActions ? hs.filter((h) => h.name != "actions") : hs;
    },
    selectableHeaders() {
      const sh = this.headers.filter(
        (h) => h.name != "menuActions" //&&  h.name != "actions"
      );
      return sh.sort(sortByFn((h) => h.name));
    },
  },

  methods: {
    dataTableReady() {
      EventBus.$emit("add-infinite-scroll");
    },
    onListOptionsUpdate(payload) {
      const listElm =
        document.querySelector(".v-data-table__wrapper") ||
        document.querySelector(".ag-body-viewport");
      if (listElm) {
        listElm.scrollTop = 0;
      }
      const sortByFieldName = payload.sortBy[0];
      //this.first = 50;
      //console.log("sort change for: ", this.refName, sortByFieldName);
      if (sortByFieldName) {
        const direction = payload.sortDesc[0] ? "DESC" : "ASC";
        this.sort = { fieldName: sortByFieldName, direction };
      } else {
        this.sort = { fieldName: "id", direction: "DESC" };
      }
      const refNameSort = this.refName
        ? `${this.refName}-sort`
        : `${this.$options.name}-sort`;
      //console.log("updating", refNameColumns);
      this.$store.dispatch("updateLocalSettings", {
        [refNameSort]: { ...this.sort },
      });
    },
    loadMore(listName) {
      this.$apollo.queries[listName].fetchMore({
        variables: { after: this[listName].pageInfo.endCursor },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEntries = fetchMoreResult[listName].edges;
          //console.log(listName, previousResult, fetchMoreResult);

          //this.loadMoreEnabled = fetchMoreResult[listName].pageInfo.hasNextPage;
          this.loadMoreEnabled =
            fetchMoreResult[listName].totalCount > this.first;

          this.first = this.first + this.pageSize;

          return {
            [listName]: {
              __typename: previousResult[listName].__typename,
              totalCount: fetchMoreResult[listName].totalCount,
              pageInfo: {
                __typename: previousResult[listName].pageInfo.__typename,
                endCursor: fetchMoreResult[listName].pageInfo.endCursor,
                hasNextPage: fetchMoreResult[listName].pageInfo.hasNextPage,
              },
              edges: [...previousResult[listName].edges, ...newEntries],
            },
          };
        },
      });
    },
    onVisibleColumnsChange(event) {
      //always check if it's on the headrs list to remove old ones from local storage
      const headers = this.headers.map((h) => h.name);
      const cols = event.filter((c) => headers.indexOf(c) > -1);
      this.visibleColumns = [...cols];
      const refNameColumns = this.refNameColumns
        ? this.refNameColumns
        : this.$options.name;
      //console.log("updating", refNameColumns, event, cols);
      this.$store.dispatch("updateLocalSettings", {
        [refNameColumns]: cols,
      });
    },
    searchParamsChanged(event) {
      this.selected = [];
      this.loadMoreEnabled = true;
      this.searchParams = { ...event };
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
    viewItem(item) {
      console.log(item);
    },
    deleteItem(item) {
      console.log(item);
    },
    editItem(item) {
      console.log(item);
      let typeName = item.__typename.replace("Edge", "").toLowerCase();
      this.$router.push("/" + typeName + "/" + item.node.id + "/edit");
    },
    onLimitChange(limit) {
      this.pageSize = limit;
      this.first = limit;
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ListMixin.js